const state = {
  progStore:
    [
      {
        id: 1,
        title_ua: "Веб-дизайнер (UI/UX Дизайнер)",
        title_en: "Web-Designer (UI/UX Designer)",
        title_es: "Diseñador web (UI/UX Diseñador)",
        regnumber_ua: "Без номера",
        regnumber_en: "Without a number",
        regnumber_es: "Sin número",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "06.07.2017",
        image: "/assets/documents/designer.webp",
      },
      {
        id: 2,
        title_ua: "Фронтенд розробник",
        title_en: "Frontend Developer",
        title_es: "Desarrollador Frontend",
        regnumber_ua: "Без номера",
        regnumber_en: "Without a number",
        regnumber_es: "Sin número",
        grade_en: "Successfully completed",
        grade_ua: "Успішно завершено",
        grade_es: "Completado con éxito",
        examdate: "23.10.2017",
        image: "/assets/documents/frontend.webp",
      }
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};